<template>
  <div class="flex flex-col w-full mx-auto p-8">
    <h1 class="text-4xl font-thin my-6 text-start">Master Data</h1>
    <div class="bg-white rounded-t-lg shadow space-x-4 flex justify-start md:text-lg text-md font-bold overflow-x-auto">
      <button
        id="locations"
        @click="setFetchString('locations')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'locations', 'bg-white': activeButton !== 'locations', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Locations
      </button>
      <!-- <button
        id="device"
        @click="setFetchString('device')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'device', 'bg-white': activeButton !== 'device', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Devices
      </button> -->
      <!-- <button
        id="devicetype"
        @click="setFetchString('devicetype')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'devicetype', 'bg-white': activeButton !== 'devicetype', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Device Types
      </button> -->
      <button
        id="users"
        @click="setFetchString('customuser')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'customuser', 'bg-white': activeButton !== 'customuser', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Users
      </button>
      <button
        id="locationcomponent"
        @click="setFetchString('locationcomponent')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'locationcomponent', 'bg-white': activeButton !== 'locationcomponent', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Components
      </button>

      <button
        id="suggestedtool"
        @click="setFetchString('suggestedtool')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'suggestedtool', 'bg-white': activeButton !== 'suggestedtool', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Spare Parts
      </button>

      <button
        id="tools"
        @click="setFetchString('tools')"
        :class="{'bg-slate-200 hover:bg-slate-200': activeButton === 'tools', 'bg-white': activeButton !== 'tools', 'hover:bg-slate-100': true}"
        class="p-3 m-1 rounded-lg"
      >
        Tools
      </button>
    </div>

    <ViewTable
      :fetch-string="fetchString"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useLocationStore } from '@/stores/locationStore'; // Import location store
import ViewTable from "@/components/ViewTable.vue";

// Setup location store
const locationStore = useLocationStore();
const fetchString = ref('masterdata/get_masterdata/?table=locations');
const activeButton = ref('locations');

// Update the fetchString to include location filter
function setFetchString(table) {
  const locationId = locationStore.selectedLocation?.id; // Get the selected location from the store
  const locationParam = locationId ? `&location=${locationId}` : ''; // Add location filter if a location is selected
  fetchString.value = `masterdata/get_masterdata/?table=${table}${locationParam}`;
  activeButton.value = table;
}

// Watch for location changes to update the fetch string
watch(() => locationStore.selectedLocation?.id, () => {
  setFetchString(activeButton.value); // Rebuild fetchString when location changes
}, { immediate: true });
</script>
